import { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

// services
import * as DashBoardService from '../../../../services/bb-api/dashboards';

export const SwedenCounter: React.FC = () => {
	const [userCount, setUserCount] = useState(0);
	const audioRef = useRef<HTMLAudioElement>(null);

	const getData = useCallback(() => {
		try {
			DashBoardService.getSwedenUserCount().then(setUserCount);
		} catch (error) {
			console.error(error);
		}
	}, []);

	useEffect(() => {
		const audio = audioRef.current;
		if (audio === null) return;
		audio.pause();
	}, []);

	useEffect(() => {
		if (userCount === 0) return;

		const audio = audioRef.current;
		if (audio === null) return;

		audio.play();
	}, [userCount]);

	useEffect(() => {
		getData();
		const oneMinute = 60 * 1000;
		const intervalId = setInterval(getData, oneMinute);
		return () => clearInterval(intervalId);
	}, [getData]);

	return (
		<StyledContainer>
			<audio autoPlay ref={audioRef}>
				<source src="/assets/diggiloo_diggiley.mp3" type="audio/mpeg" />
			</audio>
			<span>{userCount}</span>
		</StyledContainer>
	);
};

const StyledContainer = styled.main`
	position: relative;
	display: grid;
	place-content: center;
	background-color: #1A202C;

	span {
		color: white;
		opacity: 0.9;
		font-weight: bold;
		font-size: 60vh;
		z-index: 2;
	}

	::-webkit-scrollbar {
		display: none;
	}
`;
